import React from 'react';
import './body.css';
import TUTOR from './tutor.png';
// import TUTORB from './tutorb.png';
import VIDEO from './prg.mp4';
import COURSES from './courses/Courses'
import FOOTER from '../footer/Footer';


const Body = () => {
  return (
    <div className="cbody">
      <div className="bbody">
        <div className="parent">
          <div className="tutor">
            {/* <img src={TUTORB} alt="" /> */}
            <img src={TUTOR} alt="" />
          </div>
          <div className="videodiv">
            {/* car start */}

            <video src={VIDEO} className loop controls autoPlay={true}></video>

            {/* car end */}
          </div>
        </div>
        <COURSES />
        <FOOTER />
      </div>
    </div>
  );
};

export default Body;
